import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface PermissionsGateProps {
    children: React.ReactNode;
    permission: string;
    fallback?: React.ReactNode;
}

export const PermissionsGate: React.FC<PermissionsGateProps> = ({
    children,
    permission,
    fallback = null
}) => {
    const { hasPermission, isAdmin } = useAuth();

    if (!isAdmin) {
        return <>{fallback}</>;
    }

    if (hasPermission(permission)) {
        return <>{children}</>;
    }

    return <>{fallback}</>;
};
